// extracted by mini-css-extract-plugin
export default {"flex":"TableTextTop_flex__xWeXI"};